module.exports = __webpack_public_path__ + "static/thumbnail-cb5a95a2f13591b4312c2b5e0b03c571.png";